enum BreadCrumbNavigationLayoutType {
  BreadCrumbNavigationLayout = 'BreadCrumbNavigationLayout',
  BreadCrumbNavigationBlueLayout = 'BreadCrumbNavigationBlueLayout',
}

export { BreadCrumbNavigationLayoutType }
